import { ToastType } from '@components/toast';
import { subjectivityQueryKeys } from '@services/subjectivity/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useDeleteSubjectivity = (quoteId?: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = (subjectivityId: string) => {
    const url = `subjectivity/${subjectivityId}`;
    return client.delete(url);
  };
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subjectivityQueryKeys.search(quoteId) });
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(e, 'Subjectivity deletion failed');
      enqueueSnackbar(message, {
        preventDuplicate: true,
        variant: ToastType.Error,
        persist: true,
      });
    },
  });
  return { ...result, deleteSubjectivity: result.mutateAsync };
};
